import { ThemeProvider, createTheme } from "@mui/material";
import styled, { createGlobalStyle } from 'styled-components';
const theme = createTheme({
    cssVariables: true,
});
const AppGlobalStyles = createGlobalStyle`
@font-face {
  font-family: 'Poppins';
  src: url('/fonts/Poppins-Regular.ttf') format('ttf'),
  font-weight: normal;
  font-style: normal;
}
  @font-face {
  font-family: 'Poppins SemiBold';
  src: url('/fonts/Poppins-SemiBold.ttf') format('ttf')
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins Bold';
  src: url('/fonts/Poppins-Bold.ttf') format('ttf')
  font-weight: 700;
  font-style: normal;
}
:root{
    --primary-bg:#E9F4FF;
    --primary-text: #001b66;
    --secondary-btn-color:rgb(48, 72, 153);
    --primary-button-bg:#0040ff;
    --primary-button-text:#fff;
    --secondary-btn-text:#FFF;
    --input-border-color:#b2cfeb;
    --sidebar-bg:#E9F4FF;
    --label-text:rgb(84, 96, 110);
    --btn-border-radius:500px;
    --page-headings-text:rgb(27, 53, 87);
    --route-active-bg:rgb(48, 72, 153);
    --input-disabled-color:rgb(238, 238, 238);
    --route-active-text:#fff;
    --grid-cell-text: #7e8c9e;
    --holiday-indicator:rgb(255, 0, 255);
    --cream: #f9f4f1;
    --wave-black: #232426;
    --navy: #001b66;
    --energy: #2047ce;
    --white:#fff;
    --energy-hover: #0f33b1;
    --wave-white: white;
    --melon: #f1bca6;
    --lilac: #e9abff;
    --lilac-hover: #c997db;
    --floral: #9451e4;
    --carrot: #f69870;
    --carrot-hover: #e28c67;
    --navy-hover: #051749;
    --orchid: #9a9ef5;
    --powder: #e8effd;
    --cornflour: #78b7f2;
    --dark-grey: #6f7d80;
    --hunter: #0d4527;
    --hint: #4d6575;
    --ocean: #308df8;
    --fountain: #89c1d1;
    --sky: #b0e5f8;
    --stone: #c1ddee;
    --cyan: #30dfe8;
    --peach: #f5dfcc;
    --mint: #adf0cc;
    --light-steel: #b2c3d3;
    --opal: #dbc5f6;
    --alice-blue: #e8effd;
    --pro-blue: #0766d4;
    --transparent: #fff0;
    --artic: #c5fafb;
    --success: #31af36;
    --success-hover: #3ac840;
    --failed: #e4515e;
    --primary-text-hover: #1e409e;
}
body{
     font-family: Poppins;
     font-optical-sizing: auto;
     font-size: 14px;
     overflow: hidden;
}
*{
    padding:0;
    margin:0;
    box-sizing:border-box;
    font-family: Poppins !important;
}
    .tma_app_content {
    display: grid;
    grid-template-areas: 
        "header header header"
        "sidebar main main" 
        "sidebar main main";
    grid-template-columns: auto 1fr auto;
    grid-template-rows   : auto 1fr auto;
}

header.tma__app_header {
    grid-area: header;
    width: 100%;
    height: auto;
    background-color:var(--primary-bg);
}


.ag-cell,.ag-header-cell-comp-wrapper,.tma_auto_complete label{
    font-family: Poppins;
}
.tma_auto_complete label,.tma__input_container input.MuiInputBase-input::placeholder{
    font-family: Poppins !important;
}
.tma__input_container{
    .tma__input_field fieldset{
         border:1px solid var(--input-border-color) !important;
    }
    .tma__input_field{
        .Mui-error{
            fieldset{
                border:1px solid var(--mui-palette-error-main) !important;
            }
        }
    }
}
.tma_auto_complete fieldset{
     border:1px solid var(--input-border-color) !important;
}
.ag-header-viewport 
{
    background-color:var(--primary-bg);
    color:var(--primary-text);
}
.ag-cell{
    color:var(--grid-cell-text);
    a{
     color:var(--pro-blue);
    }
}
.tma_popup_menu {
  .MuiList-root.MuiList-padding {padding: 0;}
    .MuiMenu-paper{
        min-width:10%;
        li {
            font-size: 13px;
        }
    }
}
body .month_default_header,.month_default_header_inner{
    background-color:var(--white);
}
body .month_default_event .month_default_event_inner{
    margin:auto 4px 4px;
    border-radius: 4px !important;
    font-size: 10px;
}
.holiday-cell .month_default_cell_inner {
    color: red !important;
    font-weight: bold;
}
.MuiOutlinedInput-input:-webkit-autofill
{
    all:unset !important;
    width: 100% !important;
    padding: 5px !important;
}
.tma_error{
    color:red;
    font-size: 13px;
    padding-top: 4px;
    padding-left: 0.25rem;
}
body h1{
    color:var(--page-headings-text);
}
.base-Popup-root.base-Select-popup{
    z-index:99;
}
`;

export const AppThemeProvider = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <AppGlobalStyles />
            {children}
        </ThemeProvider>
    )
}

export const StyledMain = styled.main`
    grid-area: main;
    padding: ${props => props.$pageTitle === 'Login' || props.$pageTitle === 'Forgot Password' || props.$pageTitle === 'Update Project' ? '0' : '1rem'};
    height: ${props => props.$pageTitle === 'Login' || props.$pageTitle === 'Forgot Password' || props.$pageTitle === 'Update Project' ? `${props.$pageTitle === 'Update Project' ? 'calc(100% - 60px)' : '100%'}` : 'calc(100vh - 60px)'};
    overflow: auto;
    @media (max-width: 480px) {
        padding: ${props => props.$pageTitle === 'Login' || props.$pageTitle === 'Forgot Password' ? '0' : '0.5rem'};;
    }
`
export const StyledSideBar = styled.aside`
    grid-area: sidebar;
    border-right: 1px solid #ddd;
    height: calc(100vh - 60px);
    width: 260px;
    background-color: var(--primary-text);
    color:var(--primary-text);
    overflow: auto;
    transition: all 0.5s ease-in-out;
    @media (max-width: 1084px) {
        position: fixed;
        left: ${props => props.isOpen ? '0' : '-260px'};
        top: 60px;
        z-index: 9999;
    }

`
